import Vue from 'vue'
import DebugComponent from './DebugComponent'

const phoneUpperBoundary = 600
const tabletPortraitUpperBoundary = 900
const tabletLandscapeUpperBoundary = 1200
const desktopUpperBoundary = 1800

let timeout
const debounce = (callback, wait) => {
  clearTimeout(timeout)
  timeout = setTimeout(callback, wait)
}

export default {
  install (vue, options) {
    const breakpointController = new Vue({
      data: {
        currentWidth: window.innerWidth,
        // eslint-disable-next-line vue/no-reserved-keys
        _debug: null
      },
      computed: {
        'phone-only' () {
          return this.currentWidth < phoneUpperBoundary
        },
        'tablet-portrait-up' () {
          return this.currentWidth >= phoneUpperBoundary
        },
        'tablet-landscape-up' () {
          return this.currentWidth >= tabletPortraitUpperBoundary
        },
        'desktop-up' () {
          return this.currentWidth >= tabletLandscapeUpperBoundary
        },
        'big-desktop-up' () {
          return this.currentWidth >= desktopUpperBoundary
        },
        current () {
          return [
            'phone-only',
            'tablet-portrait-up',
            'tablet-landscape-up',
            'desktop-up',
            'big-desktop-up'
          ].filter(breakpoint => this[breakpoint])
        }
      },
      methods: {
        _handleResize () {
          return debounce(() => {
            this.currentWidth = window.innerWidth
            if (options.debug) this._debug.text = `${this.currentWidth}px : ${this.current}`
          }, 250)
        }
      },
      created () {
        window.addEventListener('resize', this._handleResize)
        if (options.debug) {
          this._debug = new (Vue.extend(DebugComponent))()
          this._debug.$mount()
          this._debug.text = `${this.currentWidth}px: ${this.current}`
          document.documentElement.appendChild(this._debug.$el)
        }
      },
      beforeDestroy () {
        window.removeEventListener('resize', this._handleResize)
      }
    })
    vue.prototype.$forSize = breakpointController
  }
}
